const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1a4407d86421f5a3b3698afda58941f8a567f6d1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gardens@1hive-6w"]={id:"1a4407d86421f5a3b3698afda58941f8a567f6d1"};
      